import React, { useContext } from 'react';
import { combineClassNames } from '../css';
import SvgIconContext from './SvgIconContext';

const SvgIcon = ({ name, className, ...restProps }) => {
  const icons = useContext(SvgIconContext);

  if (!name) {
    return null;
  }

  const Icon = icons[name];
  const combinedClassName = combineClassNames(
    'svg-icon',
    `svg-icon--${name}`,
    className
  );

  if (Icon) {
    return <Icon className={combinedClassName} {...restProps} />;
  }

  return null;
};

export default SvgIcon;
